/**
 * Admin dashboard router.
 *
 * Top-level structure:
 *
 *   <AuthGate>          ← cross-tenant authz; redirects non-internal users
 *     <AdminLayout/>    ← sidebar + main content outlet
 *       <Routes>
 *         /               OverviewPage
 *         /customers      CustomersPage
 *         /customers/:id  CustomerDetailPage
 *         /ai-usage       AiUsagePage
 *         /revenue        RevenuePage
 *         /marketing      StubPage
 *         /devops         StubPage
 *         /settings       StubPage
 *
 * Unknown routes redirect to ``/`` rather than 404 — the dashboard
 * is one-user so a 404 chrome would feel out of place. ``Navigate
 * replace`` keeps the history clean.
 */
import { Navigate, Route, Routes } from "react-router-dom";

import { AdminLayout } from "@/components/AdminLayout";
import { AuthGate } from "@/components/AuthGate";
import { AiUsagePage } from "@/pages/AiUsagePage";
import { CustomerDetailPage } from "@/pages/CustomerDetailPage";
import { CustomersPage } from "@/pages/CustomersPage";
import { DevOpsPage } from "@/pages/DevOpsPage";
import { NewsletterPage } from "@/pages/NewsletterPage";
import { OverviewPage } from "@/pages/OverviewPage";
import { RevenuePage } from "@/pages/RevenuePage";
import { StubPage } from "@/pages/StubPage";

export function App() {
  return (
    <AuthGate>
      <Routes>
        <Route element={<AdminLayout />}>
          <Route path="/" element={<OverviewPage />} />
          <Route path="/customers" element={<CustomersPage />} />
          <Route path="/customers/:id" element={<CustomerDetailPage />} />
          <Route path="/ai-usage" element={<AiUsagePage />} />
          <Route path="/revenue" element={<RevenuePage />} />
          <Route path="/marketing" element={<NewsletterPage />} />
          <Route path="/devops" element={<DevOpsPage />} />
          <Route path="/settings" element={<StubPage title="Settings" />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Route>
      </Routes>
    </AuthGate>
  );
}
